<div class="container-fluid animated fadeIn">
	<div class="page-header-wrapper">
		<div class="page-header">
			<div class="page-header-left">
				<div class="d-flex align-items-center flex-wrap gap-2">
					<h2 class="mb-0">{{ 'financial-movements.title' | translate }}</h2>
					<span class="title-tag neutral-tag">{{ aggregateDocument?.Document?.Type }}</span>
					<span class="title-tag">{{ aggregateDocument?.Document?.Number }}</span>
					<span class="title-tag financial-movement-state-{{ aggregateDocument?.Document?.PaymentState }}">
						{{ aggregateDocument?.Document?.PaymentState }}
					</span>
				</div>
				<eif-custom-breadcrumbs [breadcrumbItems]="breadcrumbItems"></eif-custom-breadcrumbs>
			</div>
		</div>
	</div>

	<!-- PAYMENT CARD -->
	@if (aggregateDocument) {
		<div class="simple-card top-line p-5 mb-4">
			<eif-payment-card [data]="paymentCardData"></eif-payment-card>
		</div>
	}

	<!-- TABS -->
	@if (aggregateDocument) {
		<eif-custom-tabs
			[tabs]="tabs"
			[activeTabId]="activeTabId"
			(tabChange)="onTabSelect($event)">
			<div class="ds-tab-panel">
				@switch (activeTabId) {
					@case ('movements') {
						<eif-financial-movements-details-tab
							class="animated delay-500ms fadeIn simple-card px-3"
							[aggregateDocument]="aggregateDocument"
							[loggedUser]="loggedUser"
							[documentId]="documentId">
						</eif-financial-movements-details-tab>
					}
					@case ('registration') {
						<eif-financial-movements-registration-tab
							class="animated delay-500ms fadeIn simple-card p-5"
							[aggregateDocument]="aggregateDocument">
						</eif-financial-movements-registration-tab>
					}
				}
			</div>
		</eif-custom-tabs>
	}
</div>
